import { NotificationManager } from './notification-navigator';

export const notificationManager = NotificationManager.getInstance();
